var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGiftS(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.83333 1.5H9.16667V3.27778H10.5V6.05556H9.61111V9.61111H2.38889V6.05556H1.5V3.27778H2.83333V1.5ZM3.83333 3.27778H5.5V2.5H3.83333V3.27778ZM6.5 2.5V3.27778H8.16667V2.5H6.5ZM5.5 4.27778H2.5V5.05556H5.5V4.27778ZM6.5 5.05556V4.27778H9.5V5.05556H6.5ZM5.5 6.05556H3.38889V8.61111H5.5V6.05556ZM6.5 8.61111V6.05556H8.61111V8.61111H6.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftS);
export default __webpack_public_path__ + "static/media/gift-s.11e99e3efd1929a62fc6e29ac7f5ac6c.svg";
export { ForwardRef as ReactComponent };